import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";

import { SetPrivateKey } from "../../../routes/cryptography";

import FileDownload from "js-file-download";
import { Buffer } from "buffer"

class SetPrivateKeyView extends Component {
  constructor() {
    super();
    this.state = {
      dataSet: {
        dataPrivKey: "",
        selectLevel: "128",
      },
      privkeyFileName: "файл",
      privkeyFileIsOpen: false,
    };
    this.handlePrivKeyChange = this.handlePrivKeyChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  handleSelectChange(e) {
    try {
      ////console.log(e.target.value);
      this.setState({
        dataSet: {
          ...this.state.dataSet,
          selectLevel: e.target.value,
        },
      });
    } catch (error) {
      ////console.log(error);
    }
  }
  handlePrivKeyChange() {
    try {
      const file = document.getElementById("filePrivkey").files[0];
      //console.log(file);

      if (file !== undefined) {
        this.setState({ privkeyFileName: file.name, privkeyFileIsOpen: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;
          const data = new Buffer(new Uint8Array(buffer)).toString("base64");
          this.setState({
            dataSet: { ...this.state.dataSet, dataPrivKey: data },
          });
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({ privkeyFileName: "файл", privkeyFileIsOpen: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }
  handleSubmit(e) {
    try {
      e.preventDefault();

      SetPrivateKey(
        this.state.dataSet.dataPrivKey,
        btoa(unescape(encodeURIComponent(this.state.dataSet.selectLevel)))
      ).then((result) => {
        try {
          //console.log(result);
          if (result.status === 200) {
            FileDownload(
              new Buffer(result.data.privKey, "base64").toString(),
              "tokenPrivKey.pem"
            );
            FileDownload(
              new Buffer(result.data.pubKey, "base64").toString(),
              "tokenPubKey.pem"
            );

            document.getElementById("view").style.borderColor = "green";
          } else {
            document.getElementById("view").style.borderColor = "red";

            this.setState({
              statusGenPrivKey: "Ошибка",
            });
          }
        } catch (error) {
          //console.log(error);
          document.getElementById("view").style.borderColor = "red";

          this.setState({
            statusGenPrivKey: "Ошибка",
          });
        }
      });
    } catch (error) {
      //console.log(error);
    }
  }

  componentDidMount() { }

  render() {
    return (
      <div className="container" id="genprivkey">
        <h6 className="major">Установка личного ключа в токен</h6>
        <Form onSubmit={this.handleSubmit}>
          <div className="sm-4">
            <Form.Group>
              <Form.Label>Выберите файл 32байтового ключа</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="filePrivkey"
                  onChange={this.handlePrivKeyChange}
                  isValid={this.state.privkeyFileIsOpen}
                  required
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.privkeyFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
              </Form.File>
            </Form.Group>

            <Form.Group>
              <Form.Label>Уровень стойкости ключа</Form.Label>
              <Form.Control
                onChange={this.handleSelectChange}
                defaultValue={this.state.selectLevel}
                as="select"
                custom
              >
                <option>128</option>
                <option>192</option>
                <option>256</option>
              </Form.Control>
            </Form.Group>

            <Form.Label style={{ float: "left" }}>
              {this.state.statusGenPrivKey}
            </Form.Label>
            <Button
              style={{ float: "right" }}
              type="submit"
              size="sm"
            >
              Установить
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(SetPrivateKeyView));
